import { useRoutes } from "react-router-dom";

import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import { AdminBillingView } from "./views/AdminBillingView";

export function AdminBillingRoutes() {
  const offsetTop = usePageContentOffsetTop();
  const routes = useRoutes([
    {
      path: "/",
      element: <AdminBillingView />,
    },
  ]);

  return <Container $pageContentOffsetTop={offsetTop}>{routes}</Container>;
}
